module.exports = __webpack_public_path__ + "img/inform-doc.c40787c8.png";